<div class="h-100" style="position: relative">
    @if ((isMapLoaded | async) === false) {
        <div
            class="w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75"
            style="position: absolute; z-index: 999">
            <app-load />
        </div>
    }

    <div class="card m-3" style="position: absolute; z-index: 1000">
        <div class="card-header" style="display: grid; grid-template-columns: 1fr 20px; gap: 1rem">
            <div>
                {{ 'meter-and-sensors_adjust-the-view' | translate }}
            </div>
            <i
                class="bi bi-info-circle"
                placement="right"
                [autoClose]="'outside'"
                popoverClass="custom-popover"
                container="body"
                style="height: 20px; cursor: pointer"
                [ngbPopover]="'meter-and-sensors_map-filter-information-text' | translate"></i>
        </div>
        <div class="card-body d-flex flex-column pb-0">
            <form
                [formGroup]="filterFormGroup"
                #collapse="ngbCollapse"
                [(ngbCollapse)]="isCollapsed">
                <app-input-date-range-picker
                    [required]="true"
                    [formControl]="dateRangeFormControl" />
                <app-input-dropdown-checkboxes
                    [formControl]="filterFormGroup.controls.meterType"
                    [label]="
                        'properties_meter_types' | translate: 'online' : 'common'
                    "></app-input-dropdown-checkboxes>

                <div class="mb-3">
                    <div class="form-label">
                        {{ 'event-alarms_METER_MAP_FILTER_STATUS' | translate }}
                    </div>
                    <div formGroupName="statusCheckboxes">
                        <div class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="status-1"
                                formControlName="criticalFilter" />
                            <label class="form-check-label" for="status-1">
                                {{ 'titles_critical' | translate: 'online' : 'common' }}
                            </label>
                        </div>
                        <div class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="status-2"
                                formControlName="eventFilter" />
                            <label class="form-check-label" for="status-2">
                                {{ 'titles_warning' | translate: 'online' : 'common' }}
                            </label>
                        </div>
                        <div class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="status-3"
                                formControlName="missingReadingsFilter" />
                            <label class="form-check-label" for="status-3">
                                {{ 'titles_missing_reading' | translate: 'online' : 'common' }}
                            </label>
                        </div>
                        <div class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="status-4"
                                formControlName="noAlarmsFilter" />
                            <label class="form-check-label" for="status-4">
                                {{ 'titles_readings_no_events' | translate: 'online' : 'common' }}
                            </label>
                        </div>
                    </div>
                </div>

                @if (filterFormGroup.getRawValue().status.includes('eventFilter')) {
                    <app-input-dropdown-checkboxes
                        [formControl]="filterFormGroup.controls.events"
                        [label]="'common_events' | translate"></app-input-dropdown-checkboxes>
                }
            </form>
        </div>
        <button
            type="button"
            role="button"
            class="btn btn-link p-0 align-middle text-center mb-3"
            (click)="collapse.toggle()"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="collapseExample">
            @if (!isCollapsed) {
                <i class="bi bi-chevron-up align-middle"></i>
            } @else {
                <i class="bi bi-chevron-down align-middle"></i>
            }
        </button>
    </div>

    <div id="{{ mapId }}" class="h-100 w-100"></div>
</div>

<!-- View container used for rendering templates -->
<ng-container #viewContainer></ng-container>

<ng-template #popupTemplate let-routerLink="routerLink" let-meter="meter">
    <div class="card popup">
        <div class="card-body">
            <ul class="list-group list-group-flush description-list">
                <li class="list-group-item">
                    <span>{{ 'common_BUILDINGNO' | translate: 'online' : 'common' }}</span>
                    <span>{{ meter.buildingNo }}</span>
                </li>
                <li class="list-group-item">
                    <span>{{ 'properties_proBraLoc' | translate: 'online' : 'systems' }}</span>
                    <span>{{ meter.proBraLoc }}</span>
                </li>
                <li class="list-group-item">
                    <span>{{ 'common_ADDRESS' | translate: 'online' : 'common' }}</span>
                    <span>{{ meter.address }}</span>
                </li>
                <li class="list-group-item">
                    <span>{{ 'properties_meterNo' | translate: 'online' : 'systems' }}</span>
                    <span>{{ meter.serialNo }}</span>
                </li>
                <li class="list-group-item">
                    <span>{{ 'monitoring_meterType' | translate }}</span>
                    <span>
                        {{
                            'mappers_meterType.' + meter.meterSuperTypeNo
                                | translate: 'online' : 'common'
                        }}
                    </span>
                </li>
                @if (meter.eventTypesInPeriod.length > 0) {
                    <li class="list-group-item">
                        <span>{{ 'common_events' | translate }}</span>
                        <span>
                            @for (
                                event of meter.eventTypesInPeriod;
                                track $index;
                                let last = $last
                            ) {
                                {{ 'event-alarms_' + event.eventType | translate }}
                                @if (!last) {
                                    <br />
                                }
                            }
                        </span>
                    </li>
                }

                <li class="list-group-item">
                    <span>{{ 'properties_meterModel' | translate: 'online' : 'systems' }}</span>
                    <span>
                        {{ meter.meterModel }}
                    </span>
                </li>

                <li class="list-group-item">
                    <span>{{ 'properties_mountingDate' | translate: 'online' : 'common' }}</span>
                    <span>
                        {{ meter.mountingDate | appdate }}
                    </span>
                </li>
                @if (!meter.hasReadingsInPeriod) {
                    <li class="list-group-item">
                        <span>{{ 'meter-and-sensors_reading' | translate }}</span>
                        <span>
                            {{ 'meter-and-sensors_No-reading-withing-the-period' | translate }}
                        </span>
                    </li>
                }
                @if (meter.roomId != null) {
                    <li class="list-group-item">
                        <span>{{ 'properties_placement' | translate: 'online' : 'systems' }}</span>
                        <span>
                            {{ meter.roomId }}
                        </span>
                    </li>
                }
            </ul>
        </div>
        <div class="card-footer text-body-secondary">
            <div class="d-flex justify-content-center" style="gap: 1rem">
                <a [routerLink]="routerLink">{{ 'common_SHOW' | translate }}</a>
                <a [href]="routerLink" target="_blank">{{
                    'common_show_in_new_tab' | translate
                }}</a>
            </div>
        </div>
    </div>
</ng-template>
